import { useContext } from 'react';
//mui imports====
import useStyles from './styles';
import { Grid, Paper } from '@mui/material';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import SwitchInput from '../../../../Components/SwitchInput';
import PageHeading from '../../../../Components/PageHeading';
import useCommonStyles from '../../../../commonStyles';

//===============

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

/**
 * @name UnmuteAfterInteractionConfig
 * @description This component is an editor for UnmuteAfterInteractionConfig configuration.
 *
 * UnmuteAfterInteractionConfig: {
 *   "enabled": true,
 * }
 *
 * @param {{keyData: 'featuresData.unmuteAfterInteractionConfig'}} keyData - A key used to identify the configuration in the rawConfig object.
 */
const UnmuteAfterInteractionConfig = ({ keyData }) => {
	const classes = useStyles();
	const { rawConfig, updateRawConfig } = useContext(FvpConfigContext);
	const commonStyleClasses = useCommonStyles();

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Unmute After Interaction"
				headingPath={['Dashboard', 'Fvp', 'Features Data', 'Unmute After Interaction']}
				description="Manage UAI configurations here."
			/>

			<Grid
				container
				spacing={1}
				style={{ height: '60%', width: '90%', marginLeft: '4rem', marginTop: '3rem' }}
			>
				<SwitchInput
					system={SYSTEMS.FVP_PLAYER}
					keyData={keyData + '.enabled'}
					label="Enabled"
					defaultChecked={false}
					object={rawConfig}
					updateObject={updateRawConfig}
				/>
			</Grid>
		</Paper>
	);
};

export default UnmuteAfterInteractionConfig;
